<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M23.3707 14.2091C23.7878 15.1946 24.0019 16.2541 24 17.3242C24 21.7424 20.4182 25.3242 16 25.3242C11.5818 25.3242 8 21.7424 8 17.3242C8 12.906 11.5818 9.32422 16 9.32422C17.452 9.32422 18.8133 9.71089 19.9871 10.3873"
      stroke="white"
      stroke-width="0.888889"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.4772 7L15.9999 19.2498L11.4075 14.8053V16.9907L16.1666 21.6573L24.4772 9.60178V7Z"
      fill="white"
      stroke="white"
      stroke-width="0.888889"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
